import React, { useState } from 'react';
import {
  Box, Typography, Button, Radio, RadioGroup,
  FormControlLabel, FormControl, Paper, Chip, Alert
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const QuizComponent = ({ quiz, onComplete, alreadyPassed, savedScore, onContinue }) => {
  const [answers, setAnswers] = useState({});

  const { quizTitle, passingScore = 70, questions = [] } = quiz;

  const handleChange = (index, value) => {
    setAnswers(prev => ({ ...prev, [index]: value }));
  };

  const handleSubmit = () => {
    let correct = 0;
    questions.forEach((q, i) => {
      if (answers[i] === q.answer) correct++;
    });
    const score = Math.round((correct / questions.length) * 100);
    const passed = score >= passingScore;
    onComplete(answers, score, passed);
  };

  const allAnswered = questions.length > 0 && Object.keys(answers).length === questions.length;

  if (alreadyPassed) {
    return (
      <Box textAlign="center" py={5}>
        <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
        <Typography variant="h5" color="success.main" fontWeight="bold" gutterBottom>
          Quiz Already Passed
        </Typography>
        <Typography variant="h6" gutterBottom color="text.secondary">
          Your score: {savedScore}%
        </Typography>
        <Chip label="PASSED" color="success" sx={{ fontSize: '1rem', px: 2, py: 3, mb: 3 }} />
        <Box>
          <Button variant="contained" color="success" size="large" onClick={onContinue}>
            Continue to Next Course
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {quizTitle}
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {questions.length} questions — {passingScore}% required to pass
      </Typography>
      <Alert severity="info" sx={{ mb: 3 }}>
        Answer all questions, then click Submit. You can retry as many times as needed.
      </Alert>

      {questions.map((q, i) => (
        <Paper key={i} elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            {i + 1}. {q.question}
          </Typography>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              value={answers[i] || ''}
              onChange={(e) => handleChange(i, e.target.value)}
            >
              {q.options.map((opt, j) => (
                <FormControlLabel
                  key={j}
                  value={opt}
                  control={<Radio />}
                  label={opt}
                  sx={{
                    borderRadius: 1,
                    mb: 0.5,
                    px: 1,
                    transition: 'background 0.15s',
                    '&:hover': { bgcolor: 'action.hover' }
                  }}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Paper>
      ))}

      <Box textAlign="center" mt={3} pb={2}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {Object.keys(answers).length} of {questions.length} answered
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleSubmit}
          disabled={!allAnswered}
          sx={{ px: 6, py: 1.5, fontSize: '1rem' }}
        >
          Submit Quiz
        </Button>
      </Box>
    </Box>
  );
};

export default QuizComponent;
